import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const BetweenAds = ({ detail }) => {
  const handleClick = () => {
    window.open(detail.link, '_blank');
  };
  return (
    <>
      <div onClick={() => handleClick()} className='w-full max-w-[910px] mx-auto '>
        <p className='text-left mb-2 text-[11px] sm:text-sm tracking-[0.18em] text-[#6B7280] font-semibold ml-5'>ADVERTISEMENT</p>
        <div className="rounded-[24px] overflow-hidden shadow-lg bg-white">
          <a href={detail.link} target="_blank" rel="noreferrer">
            <img className="w-full rounded-t-[24px] cursor-pointer  object-contain" src={detail.advertiseImage} alt="advertise Image" />
          </a>
          {/* <div className="px-3 py-4 flex flex-col md:flex-row items-start md:items-center justify-between">

            <div className="flex flex-col md:flex-row items-start md:items-center gap-3">

              <div className="flex-shrink-0">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden">
                  <LazyLoadImage
                    src={detail.companyLogoImage}
                    alt="logo"
                    effect="blur"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div>
                <div className="font-bold text-lg">{detail.title}</div>
                <p className="text-gray-700 text-sm w-full md:w-[90%]">
                  {detail.description}
                </p>
              </div>

            </div>

            <button className="text-xs mt-3 md:mt-0 md:text-sm lg:text-base font-medium border bg-[#097FE6] text-white py-2 px-4 rounded-full hover:font-semibold">
              <a href={detail.link} target="_blank" rel="noreferrer">
                Enquiry
              </a>
            </button>

          </div> */}
        </div>
      </div>
    </>
  )
}

export default BetweenAds